let selectedPiece = 43;
let sleeveAttached = true;
let soundOn = false;
let currentQuoteIndex = 0;
let collectorName = "COLLECTOR";
let asmrAudioEngineActive = true;
let audioCtx = null;

const CFG = window.LAHFAH || {};
const claimedPieces = new Set();

const founderQuotes = [
    `"Note to collector: Wear it in the rain, let the deep black fade naturally into washed charcoal."`,
    `"Note to collector: Modular sleeves allow 2-in-1 styling across all four seasons."`,
    `"Note to collector: Designed for slow morning routines, warm coffee cups, and wherever your thoughts wander today."`,
    `"Note to collector: Like a favorite study corner, may this heavy fleece feel like home no matter where you open your books."`,
    `"Note to collector: May this fleece keep you as warm on quiet solo walks as it does in crowded rooms."`,
    `"Note to collector: Take your time today. This piece isn't built to rush through seasons with you."`,
    `"Note to collector: Whenever the world feels too loud, pull the hood up and let the heavy fleece hold you close."`,
    `"Note to collector: Like a favorite book, this garment gets better with every coffee stain and folded sleeve."`,
    `"Note to collector: You wear the memory of everywhere you've been. Let this piece record the journey."`,
    `"Note to collector: 400+ GSM fleece gets softer after every 50 days of continuous wear."`
];

window.addEventListener('DOMContentLoaded', () => {
    renderMatrixGrid();
    updatePieceSelectionUI();
    initASMRCanvas();

    window.addEventListener('mousemove', (e) => {
        const chestTarget = document.getElementById('urdu-chest-target');
        if (chestTarget) {
            const rect = chestTarget.getBoundingClientRect();
            const centerX = rect.left + rect.width / 2;
            const centerY = rect.top + rect.height / 2;
            const dist = Math.round(Math.hypot(e.clientX - centerX, e.clientY - centerY));
            
            const radarText = document.getElementById('radar-distance-text');
            if (radarText) radarText.innerText = `DISTANCE TO EMBROIDERY: ${dist}px`;
        }
    });

    refreshCart();
});

function handleASMRpad(e) {
    const pad = document.getElementById('asmr-touchpad');
    if (!pad) return;
    const rect = pad.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const freq = Math.round(200 + (x / rect.width) * 600 + (y / rect.height) * 200);
    const freqText = document.getElementById('asmr-freq-text');
    if (freqText) freqText.innerText = `FREQ: ${freq} HZ • ASMR ACTIVE`;

    spawnDustParticle(x, y);

    if (asmrAudioEngineActive) {
        playASMRTone(freq);
    }
}

function stopASMRpad() {
    const freqText = document.getElementById('asmr-freq-text');
    if (freqText) freqText.innerText = `FREQ: 0 HZ • TOUCH PAD READY`;
}

function toggleASMRengine() {
    asmrAudioEngineActive = !asmrAudioEngineActive;
    const btn = document.getElementById('asmr-toggle-btn');
    if (btn) {
        btn.innerHTML = asmrAudioEngineActive 
            ? `<span>🔊 AUDIO ENGINE: ACTIVE (ASMR ON)</span>` 
            : `<span>🔇 AUDIO ENGINE: MUTED (ASMR OFF)</span>`;
    }
}

function playASMRTone(freq) {
    try {
        if (!audioCtx) audioCtx = new (window.AudioContext || window.webkitAudioContext)();
        if (audioCtx.state === 'suspended') audioCtx.resume();

        const now = audioCtx.currentTime;
        const osc1 = audioCtx.createOscillator();
        osc1.type = 'sine';
        const warmFreq = 60 + (freq % 120);
        osc1.frequency.setValueAtTime(warmFreq, now);

        const osc2 = audioCtx.createOscillator();
        osc2.type = 'sine';
        osc2.frequency.setValueAtTime(warmFreq * 1.25, now);

        const filter = audioCtx.createBiquadFilter();
        filter.type = 'lowpass';
        filter.frequency.setValueAtTime(220, now);

        const gain = audioCtx.createGain();
        gain.gain.setValueAtTime(0.001, now);
        gain.gain.linearRampToValueAtTime(0.018, now + 0.12);
        gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.6);

        osc1.connect(filter);
        osc2.connect(filter);
        filter.connect(gain);
        gain.connect(audioCtx.destination);

        osc1.start(now);
        osc2.start(now);
        osc1.stop(now + 0.6);
        osc2.stop(now + 0.6);
    } catch (err) {}
}

let particles = [];
function initASMRCanvas() {
    const canvas = document.getElementById('asmr-canvas');
    if (!canvas) return;
    const ctx = canvas.getContext('2d');

    function resize() {
        canvas.width = canvas.parentElement.clientWidth;
        canvas.height = canvas.parentElement.clientHeight;
    }
    resize();
    window.addEventListener('resize', resize);

    function loop() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        for (let i = particles.length - 1; i >= 0; i--) {
            const p = particles[i];
            p.x += p.vx;
            p.y += p.vy;
            p.alpha -= 0.02;
            if (p.alpha <= 0) {
                particles.splice(i, 1);
                continue;
            }
            ctx.fillStyle = `rgba(249, 226, 230, ${p.alpha})`;
            ctx.beginPath();
            ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
            ctx.fill();
        }
        requestAnimationFrame(loop);
    }
    loop();
}

function spawnDustParticle(x, y) {
    particles.push({
        x: x,
        y: y,
        vx: (Math.random() - 0.5) * 2,
        vy: (Math.random() - 0.5) * 2,
        size: Math.random() * 3 + 1,
        alpha: 0.8
    });
}

function toggleAccordion(id) {
    const content = document.getElementById(id);
    const icon = document.getElementById(`${id}-icon`);
    if (content) {
        content.classList.toggle('hidden');
        if (icon) icon.classList.toggle('rotate-180');
    }
}

function renderMatrixGrid() {
    const grid = document.getElementById('pieces-grid');
    if (!grid) return;
    grid.innerHTML = '';

    for (let i = 1; i <= 100; i++) {
        const numStr = `#${String(i).padStart(3, '0')}`;
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.innerText = numStr;

        if (claimedPieces.has(i)) {
            btn.className = 'py-2 border border-cocoa-text bg-cocoa-text text-oatmeal text-[10px] font-mono font-bold rounded-xl cursor-not-allowed opacity-90 shadow-none';
            btn.title = 'Claimed by another collector';
            btn.disabled = true;
        } else if (i === selectedPiece) {
            btn.className = 'py-2 border-2 border-cocoa-text bg-blush-pink text-cocoa-text text-[10px] font-mono font-bold rounded-xl shadow-tactile scale-105 transition-all';
            btn.onclick = () => selectPiece(i);
        } else {
            btn.className = 'py-2 border border-cocoa-text/40 bg-cream text-cocoa-text text-[10px] font-mono font-bold rounded-xl hover:bg-butter-yellow hover:border-cocoa-text transition-all active:scale-95';
            btn.onclick = () => selectPiece(i);
        }

        grid.appendChild(btn);
    }
}

function selectPiece(num) {
    if (claimedPieces.has(num)) return;
    selectedPiece = num;
    renderMatrixGrid();
    updatePieceSelectionUI();
}

function randomAllocate() {
    const available = [];
    for (let i = 1; i <= 100; i++) {
        if (!claimedPieces.has(i)) available.push(i);
    }
    if (available.length > 0) {
        const randomPiece = available[Math.floor(Math.random() * available.length)];
        selectPiece(randomPiece);
    }
}

function updatePieceSelectionUI() {
    const formatted = `#${String(selectedPiece).padStart(3, '0')}`;
    
    const selectedBadge = document.getElementById('selected-number-badge');
    if (selectedBadge) selectedBadge.innerText = formatted;

    const heroCta = document.getElementById('hero-cta-label');
    if (heroCta) heroCta.innerText = `SECURE PIECE (${formatted}/100)`;

    const certAllocated = document.getElementById('cert-allocated-piece');
    if (certAllocated) certAllocated.innerText = `${formatted} / 100`;

    const stampPiece = document.getElementById('stamp-piece-no');
    if (stampPiece) stampPiece.innerText = `PIECE ${formatted}`;

    const cartPiece = document.getElementById('cart-piece-display');
    if (cartPiece) cartPiece.innerText = formatted;
}

function setModularityMode(mode) {
    sleeveAttached = (mode === 'A');

    const pillText = document.getElementById('hero-mode-text');
    const modeDot = document.getElementById('mode-dot');
    const mockupImg = document.getElementById('mockup-display-img');

    const tabA = document.getElementById('tab-mode-a');
    const tabB = document.getElementById('tab-mode-b');

    const modeTitle = document.getElementById('mode-title');
    const modeDesc = document.getElementById('mode-desc');
    const modeFeatures = document.getElementById('mode-features');
    const modeTimeDisplay = document.getElementById('mode-time-display');
    const modeTimeDesc = document.getElementById('mode-time-desc');
    const modeRetentionTag = document.getElementById('mode-retention-tag');

    if (sleeveAttached) {
        if (pillText) pillText.innerText = "MODE A: FULL SLEEVE SWEATSHIRT";
        if (modeDot) modeDot.className = "w-2 h-2 rounded-full bg-amber-500 animate-pulse";
        if (mockupImg) mockupImg.src = CFG.imgA;

        if (tabA) {
            tabA.className = "w-1/2 py-3 px-4 rounded-xl border-2 border-cocoa-text bg-butter-yellow font-mono text-xs font-bold text-cocoa-text flex items-center justify-center gap-2 shadow-tactile-sm transition-all";
        }
        if (tabB) {
            tabB.className = "w-1/2 py-3 px-4 rounded-xl border border-transparent font-mono text-xs font-bold text-cocoa-light flex items-center justify-center gap-2 hover:text-cocoa-text transition-all";
        }

        if (modeTitle) modeTitle.innerText = "Mode A — Full Heavyweight Silhouette";
        if (modeDesc) modeDesc.innerText = "Full coverage 400+ GSM double-brushed organic fleece. High-density 3D puff print running along the outer forearm seam reading 'ONLY IF YOU KNOW'.";
        if (modeFeatures) {
            modeFeatures.innerHTML = `
                <li class="flex items-center gap-2.5">
                    <i class="fa-solid fa-check text-emerald-600 text-xs"></i>
                    <span>Matte press snaps fully concealed</span>
                </li>
                <li class="flex items-center gap-2.5">
                    <i class="fa-solid fa-check text-emerald-600 text-xs"></i>
                    <span>Ribbed heavyweight wrist cuffs</span>
                </li>
                <li class="flex items-center gap-2.5">
                    <i class="fa-solid fa-check text-emerald-600 text-xs"></i>
                    <span>Full cold-weather thermal insulation</span>
                </li>
            `;
        }
        if (modeTimeDisplay) modeTimeDisplay.innerText = "< 9 Seconds";
        if (modeTimeDesc) modeTimeDesc.innerText = "Custom press snaps permit instant detachment without snags.";
        if (modeRetentionTag) modeRetentionTag.innerText = "Included Travel Pouch";

    } else {
        if (pillText) pillText.innerText = "MODE B: SHORT-SLEEVE VEST TRANSITION";
        if (modeDot) modeDot.className = "w-2 h-2 rounded-full bg-emerald-500 animate-pulse";
        if (mockupImg) mockupImg.src = CFG.imgB;

        if (tabA) {
            tabA.className = "w-1/2 py-3 px-4 rounded-xl border border-transparent font-mono text-xs font-bold text-cocoa-light flex items-center justify-center gap-2 hover:text-cocoa-text transition-all";
        }
        if (tabB) {
            tabB.className = "w-1/2 py-3 px-4 rounded-xl border-2 border-cocoa-text bg-butter-yellow font-mono text-xs font-bold text-cocoa-text flex items-center justify-center gap-2 shadow-tactile-sm transition-all";
        }

        if (modeTitle) modeTitle.innerText = "Mode B — Detached Short-Sleeve Vest";
        if (modeDesc) modeDesc.innerText = "Relaxed summer boxy vest profile. Sleeves detach neatly at the shoulder line and store safely in the included canvas pouch.";
        if (modeFeatures) {
            modeFeatures.innerHTML = `
                <li class="flex items-center gap-2.5">
                    <i class="fa-solid fa-check text-emerald-600 text-xs"></i>
                    <span>Breathable open-shoulder armholes</span>
                </li>
                <li class="flex items-center gap-2.5">
                    <i class="fa-solid fa-check text-emerald-600 text-xs"></i>
                    <span>Concealed press snap lip protects skin</span>
                </li>
                <li class="flex items-center gap-2.5">
                    <i class="fa-solid fa-check text-emerald-600 text-xs"></i>
                    <span>Four-season climate versatility</span>
                </li>
            `;
        }
        if (modeTimeDisplay) modeTimeDisplay.innerText = "< 9 Seconds";
        if (modeTimeDesc) modeTimeDesc.innerText = "Quick-release mechanism designed for seamless on-the-go adjustments.";
        if (modeRetentionTag) modeRetentionTag.innerText = "Stashed in Storage Pouch";
    }
}

function triggerProximityAlert() {
    const alertBox = document.getElementById('proximity-alert-box');
    alertBox.classList.remove('opacity-0', 'pointer-events-none', 'scale-90');
    alertBox.classList.add('opacity-100', 'scale-100');
}

function closeProximityAlert() {
    const alertBox = document.getElementById('proximity-alert-box');
    alertBox.classList.add('opacity-0', 'pointer-events-none', 'scale-90');
    alertBox.classList.remove('opacity-100', 'scale-100');
}

function openCertificateModal() {
    const modal = document.getElementById('modal-certificate');
    const nameInput = document.getElementById('collector-name-input');
    
    if (nameInput) nameInput.value = '';
    collectorName = '';
    
    const certPresented = document.getElementById('cert-presented-name');
    if (certPresented) {
        certPresented.innerText = 'AWAITING NAME...';
        certPresented.className = 'font-bold bg-blush-pink/60 px-3 py-1 rounded border border-cocoa-text/30 text-cocoa-light italic';
    }

    const stamp = document.getElementById('cert-stamp');
    if (stamp) {
        stamp.classList.remove('animate-stamp');
        stamp.classList.add('opacity-0', 'pointer-events-none');
    }

    const confirmBtn = document.getElementById('confirm-reserve-btn');
    if (confirmBtn) {
        confirmBtn.disabled = true;
        confirmBtn.className = "w-full mt-6 py-4 bg-cocoa-text/40 text-cream/70 font-mono text-xs font-bold rounded-2xl cursor-not-allowed transition-all flex items-center justify-center gap-2";
        confirmBtn.innerHTML = `<i class="fa-solid fa-lock"></i><span>ENTER NAME TO LOCK ALLOCATION</span>`;
    }

    modal.classList.remove('opacity-0', 'pointer-events-none');
    modal.children[0].classList.remove('scale-95');
}

function closeCertificateModal() {
    const modal = document.getElementById('modal-certificate');
    modal.classList.add('opacity-0', 'pointer-events-none');
    modal.children[0].classList.add('scale-95');
}

let nameTypingTimer = null;

function updateCertificateName(val) {
    collectorName = val.trim();
    const certPresented = document.getElementById('cert-presented-name');
    const stamp = document.getElementById('cert-stamp');
    const confirmBtn = document.getElementById('confirm-reserve-btn');

    if (stamp) {
        stamp.classList.remove('animate-stamp');
        stamp.classList.add('opacity-0', 'pointer-events-none');
    }

    if (nameTypingTimer) clearTimeout(nameTypingTimer);

    if (collectorName.length > 0) {
        if (certPresented) {
            certPresented.innerText = collectorName.toUpperCase();
            certPresented.className = 'font-bold bg-blush-pink px-3 py-1 rounded border border-cocoa-text text-cocoa-text';
        }

        nameTypingTimer = setTimeout(() => {
            if (stamp) {
                stamp.classList.remove('opacity-0', 'pointer-events-none');
                stamp.classList.add('animate-stamp');
            }
        }, 600);

        if (confirmBtn) {
            confirmBtn.disabled = false;
            confirmBtn.className = "w-full mt-6 py-4 bg-cocoa-text text-cream font-mono text-xs font-bold rounded-2xl shadow-tactile hover:bg-cocoa-light transition-all flex items-center justify-center gap-2 cursor-pointer";
            confirmBtn.innerHTML = `<i class="fa-solid fa-check"></i><span>CONFIRM & LOCK ALLOCATION</span>`;
        }
    } else {
        if (certPresented) {
            certPresented.innerText = 'AWAITING NAME...';
            certPresented.className = 'font-bold bg-blush-pink/60 px-3 py-1 rounded border border-cocoa-text/30 text-cocoa-light italic';
        }

        if (confirmBtn) {
            confirmBtn.disabled = true;
            confirmBtn.className = "w-full mt-6 py-4 bg-cocoa-text/40 text-cream/70 font-mono text-xs font-bold rounded-2xl cursor-not-allowed transition-all flex items-center justify-center gap-2";
            confirmBtn.innerHTML = `<i class="fa-solid fa-lock"></i><span>ENTER NAME TO LOCK ALLOCATION</span>`;
        }
    }
}

async function confirmReservation() {
    const btn = document.getElementById('confirm-reserve-btn');
    if (btn) { btn.disabled = true; btn.innerHTML = '<span>ADDING TO BAG…</span>'; }
    const ok = await addPieceToCart();
    if (ok) {
        closeCertificateModal();
        openCartDrawer();
    } else if (btn) {
        btn.disabled = false;
        btn.innerHTML = '<i class="fa-solid fa-check"></i><span>CONFIRM & LOCK ALLOCATION</span>';
    }
}

function reachInsidePocket() {
    openFoundersNote(currentQuoteIndex);
    currentQuoteIndex = (currentQuoteIndex + 1) % founderQuotes.length;
}

function openFoundersNote(index = 0) {
    currentQuoteIndex = index;
    const quoteElem = document.getElementById('founders-quote-text');
    if (quoteElem) {
        quoteElem.innerText = founderQuotes[currentQuoteIndex % founderQuotes.length];
    }
    const modal = document.getElementById('modal-founders-note');
    if (modal) {
        modal.classList.remove('opacity-0', 'pointer-events-none');
        modal.children[0].classList.remove('scale-95');
    }
}

function closeFoundersNote() {
    const modal = document.getElementById('modal-founders-note');
    if (modal) {
        modal.classList.add('opacity-0', 'pointer-events-none');
        modal.children[0].classList.add('scale-95');
    }
}

function openStashCareModal() {
    const modal = document.getElementById('modal-stash-care');
    if (modal) {
        modal.classList.remove('opacity-0', 'pointer-events-none');
        modal.children[0].classList.remove('scale-95');
    }
}

function closeStashCareModal() {
    const modal = document.getElementById('modal-stash-care');
    if (modal) {
        modal.classList.add('opacity-0', 'pointer-events-none');
        modal.children[0].classList.add('scale-95');
    }
}

function downloadWallpaper(type) {
    alert(`Downloading Drop 001 ${type.toUpperCase()} Wallpaper asset...`);
}

function openLogWearModal() {
    const modal = document.getElementById('modal-log-wear');
    if (modal) {
        modal.classList.remove('opacity-0', 'pointer-events-none');
        modal.children[0].classList.remove('scale-95');
    }
}

function closeLogWearModal() {
    const modal = document.getElementById('modal-log-wear');
    if (modal) {
        modal.classList.add('opacity-0', 'pointer-events-none');
        modal.children[0].classList.add('scale-95');
    }
}

function submitWearLog() {
    const dayNo = document.getElementById('log-day-no').value;
    const location = document.getElementById('log-location').value;
    const notes = document.getElementById('log-notes').value;

    if (!dayNo || !location || !notes) {
        alert('Please complete all log entry fields.');
        return;
    }

    alert('Your 1,000-Day Archive entry has been submitted for verification!');
    closeLogWearModal();
}

function toggleCartDrawer() {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    const opening = drawer.classList.contains('translate-x-full');
    if (opening) refreshCart();
    drawer.classList.toggle('translate-x-full');
}
function openCartDrawer() {
    const drawer = document.getElementById('cart-drawer');
    if (drawer) drawer.classList.remove('translate-x-full');
}

function scrollToSection(id) {
    const elem = document.getElementById(id);
    if (elem) {
        elem.scrollIntoView({ behavior: 'smooth' });
    }
}

function toggleSound() {
    soundOn = !soundOn;
    const audio = document.getElementById('ambient-audio');
    const icon = document.getElementById('sound-icon');

    if (soundOn) {
        if (audio) audio.play().catch(() => {});
        if (icon) icon.className = "fa-solid fa-volume-high text-cocoa-text";
    } else {
        if (audio) audio.pause();
        if (icon) icon.className = "fa-solid fa-volume-xmark text-cocoa-text";
    }
}

/* ================= SHOPIFY CART (Ajax API) ================= */
function esc(s) {
    return String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
}
function fmtMoney(cents) {
    try {
        return new Intl.NumberFormat(CFG.locale || undefined, { style: 'currency', currency: CFG.currency || 'USD' }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
}

async function addPieceToCart() {
    const sel = document.getElementById('variant-select');
    const id = sel ? sel.value : CFG.variantId;
    if (!id) { alert('This drop is not linked to a product yet.'); return false; }
    const piece = `#${String(selectedPiece).padStart(3, '0')} / 100`;
    try {
        const res = await fetch(CFG.cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(id), quantity: 1, properties: { 'Piece Number': piece, 'Collector Name': collectorName } }] })
        });
        if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            alert(err.description || 'Could not add this piece to your bag.');
            return false;
        }
        await refreshCart();
        return true;
    } catch (e) {
        alert('Network error. Please try again.');
        return false;
    }
}

async function refreshCart() {
    try {
        const res = await fetch(CFG.cartUrl, { headers: { 'Accept': 'application/json' } });
        renderCart(await res.json());
    } catch (e) {}
}

async function removeCartLine(key) {
    try {
        const res = await fetch(CFG.cartChangeUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 })
        });
        renderCart(await res.json());
    } catch (e) {}
}

function renderCart(cart) {
    const badge = document.getElementById('cart-count-badge');
    if (badge) badge.innerText = cart.item_count;

    const wrap = document.getElementById('cart-items');
    const sub = document.getElementById('cart-subtotal');
    const form = document.getElementById('cart-checkout-form');
    if (sub) sub.innerText = fmtMoney(cart.total_price);
    if (form) form.classList.toggle('hidden', cart.item_count === 0);
    if (!wrap) return;

    if (cart.item_count === 0) {
        wrap.innerHTML = `<div class="font-mono text-xs text-cocoa-light text-center py-10 border-2 border-dashed border-cocoa-text/30 rounded-2xl">YOUR BAG IS EMPTY.<br>CLAIM A PIECE TO BEGIN.</div>`;
        return;
    }
    wrap.innerHTML = cart.items.map(item => {
        const props = Object.entries(item.properties || {}).filter(([k, v]) => v)
            .map(([k, v]) => `<div class="text-xs font-mono bg-butter-yellow border border-cocoa-text px-2 py-1 rounded inline-block mb-1 mr-1">${esc(k).toUpperCase()}: <span class="font-bold">${esc(v)}</span></div>`).join('');
        const variant = item.variant_title ? esc(item.variant_title).toUpperCase() : 'IN STOCK';
        return `
        <div class="bg-oatmeal border-2 border-cocoa-text rounded-2xl p-4 shadow-tactile-sm mb-4">
            <div class="flex justify-between items-start mb-2 gap-3">
                <div>
                    <div class="font-bold font-serif text-base text-cocoa-text">${esc(item.product_title)}</div>
                    <div class="text-xs font-mono text-cocoa-light">${variant}</div>
                </div>
                <span class="font-mono font-bold text-sm text-cocoa-text">${fmtMoney(item.final_line_price)}</span>
            </div>
            <div>${props}</div>
            <div class="flex items-center justify-between text-xs font-mono text-cocoa-light pt-2 mt-2 border-t border-cocoa-text/10">
                <span>QTY: ${item.quantity}</span>
                <button type="button" onclick="removeCartLine('${esc(item.key)}')" class="underline font-bold hover:text-cocoa-text">REMOVE</button>
            </div>
        </div>`;
    }).join('');
}
window.toggleCartDrawer = function() {
    const drawer = document.getElementById('cart-drawer');
    if (drawer) {
        drawer.classList.toggle('translate-x-full');
    }
};

window.openStashCareModal = function() {
    const modal = document.getElementById('modal-stash-care');
    if (modal) modal.classList.remove('opacity-0', 'pointer-events-none');
};